import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { useRootStore } from 'store/rootStore';
import { toJS } from 'mobx';
import { UserRoleTypes } from 'types/aaaService';
import ChangeAgencyForm from '../ChangeAgencyForm';
import SignedInContentWrapper from '../SignedInContentWrapper';

interface SingleRoleTypeContentProps {
  roleType: UserRoleTypes;
}

const SingleRoleTypeContent = observer(({ roleType }: SingleRoleTypeContentProps): JSX.Element => {
  // Mobx store
  const {
    roleTypeAndAgencyStore: {
      loading,
      allAgencies,
      isMultiAgencySelectionAvailable,
      isAgencyFormValid,
      saveAndContinueWithUserSelection,
      sendLogoutUserRequest,
    },
  } = useRootStore();

  // Converted Data
  const convertedAgencies = allAgencies.map((agency) => toJS(agency)).slice();

  // EE and AGENT with no multi agency selection should be redirected to
  // the dashboard without role type and agency selection view
  useEffect(() => {
    if (
      roleType === 'EE' ||
      (roleType === 'AGENT' && convertedAgencies.length > 0 && !isMultiAgencySelectionAvailable)
    ) {
      void saveAndContinueWithUserSelection();
    }
  }, []);

  if (roleType === 'AGENT' && isMultiAgencySelectionAvailable) {
    return (
      <SignedInContentWrapper
        content={<ChangeAgencyForm />}
        isValidToContinue={isAgencyFormValid}
        onContinue={saveAndContinueWithUserSelection}
        onLogout={sendLogoutUserRequest}
        sessionLoading={loading}
      />
    );
  }
  return <></>;
});

export default SingleRoleTypeContent;
